import { Tag } from '@cian/components';
import * as React from 'react';

import { tagThemeSmall } from '../tag_theme';
import { INewbuildingHouseTag } from '../../../state/tags/definitions/geo/newbuilding_houses';
import { TagNew } from '../TagNew';

export interface INewbuildingHousegItemProps {
  tag: INewbuildingHouseTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const NewbuildingHouseTagItem = (props: INewbuildingHousegItemProps) => {
  const TagComponent = React.useMemo(() => (props.withNewTag ? TagNew : Tag), [props.withNewTag]);

  return (
    <TagComponent onDeleteClick={props.onDeleteClick} tagStyles={tagThemeSmall}>
      {props.tag.text}
    </TagComponent>
  );
};
